<template>
  <dl class="input-block">
    <dt>決済情報</dt>
    <dd>
      <SelectBox class="select-box" required v-model.number="_value" :disabled="isDisabled" :items="settlements" />
      <p v-if="isSettlement" class="coupon-point">
        {{ couponPoint(reserve) }}<span class="note">{{ couponPointNote(reserve) }}</span>
      </p>
    </dd>
  </dl>
</template>

<script>
import { mapState } from 'vuex'
import { couponPoint, couponPointNote } from '@/utils/reserve'
import SelectBox from '@/components/atoms/SelectBox'
import { getSettlementMapBySyncType } from '@/resources/reservation/settlementMap'
import { isBlock } from '@/resources/reservation/typeMap'

export default {
  name: 'SettlementInput',
  components: {
    SelectBox,
  },
  props: {
    reserve: { type: Object, default: () => ({}) },
  },
  computed: {
    ...mapState({
      settlement: state => state.reserves.edit.reservation.settlement,
      syncType: state => state.reserves.edit.reservation.syncType || 0,
      type: state => state.reserves.edit.reservation.type,
    }),
    _value: {
      get() {
        return this.settlement || 0
      },
      set(value) {
        this.$store.commit('reserves/edit/update', { settlement: +value })
      },
    },
    settlements() {
      return getSettlementMapBySyncType(this.syncType, this._value)
    },
    isDisabled() {
      // ポイント利用 or スマート決済 or 外国語／法人予約 or ブロック予約
      return [3, 7].includes(this._value) || [5, 6].includes(this.syncType) || isBlock(this.type)
    },
    isSettlement() {
      const { settlementPoint, coupon } = this.reserve
      return settlementPoint || !!coupon?.discount
    },
  },
  methods: { couponPoint, couponPointNote },
}
</script>

<style lang="postcss" scoped>
.select-box {
  margin-top: 8px;
  width: 224px;
}

.coupon-point {
  left: 240px;
  position: absolute;
  top: 16px;
  word-break: keep-all;

  .note {
    font-size: 13px;
  }

  .responsive & {
    @media screen and (--sp-size) {
      font-size: 13px;
      margin-top: 8px;
      position: static;
    }
  }
}
</style>
